import React from 'react';
import { Text } from '@chakra-ui/react';

interface Props {
  text?: string;
  className?: string;
  children?: React.ReactNode;
}

const FormErrorMessage: React.FC<Props> = ({ text, className, children }) => (
  <Text
    className={`form-error-message ${className ?? ''}`}
    fontSize='sm'
    color='red.500'
    mt={1}
  >
    {text}
    {children}
  </Text>
);

export default FormErrorMessage;
